import Factory from "@/schemas/factory";

const schema = new Factory()
    .hasId()
    .make();

schema.prop('moduleId').setType(Number);
schema.prop('serviceId').setType(Number);

export default schema;
